import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { I18nProvider } from "./lib/i18n";
import { AuthProvider } from "./lib/auth";

import Landing from "./pages/Landing";
import Chat from "./pages/Chat";
import Pricing from "./pages/Pricing";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/AdminLayout";
import AdminDashboard from "./pages/AdminDashboard";
import AdminDocuments from "./pages/AdminDocuments";
import AdminUpload from "./pages/AdminUpload";
import AdminSearch from "./pages/AdminSearch";
import AdminFeedback from "./pages/AdminFeedback";
import AdminUsers from "./pages/AdminUsers";
import AdminSubscriptions from "./pages/AdminSubscriptions";
import AdminSettings from "./pages/AdminSettings";
import AdminProfile from "./pages/AdminProfile";
import AdminAudit from "./pages/AdminAudit";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import SubscriberLogin from "./pages/SubscriberLogin";
import SubscriberRegister from "./pages/SubscriberRegister";
import SubscriberForgotPassword from "./pages/SubscriberForgotPassword";
import SubscriberResetPassword from "./pages/SubscriberResetPassword";
import AdminPasswordResets from "./pages/AdminPasswordResets";
import PaymentSuccess from "./pages/PaymentSuccess";
import SubscriberDashboard from "./pages/SubscriberDashboard";
import AdminSuperDashboard from "./pages/AdminSuperDashboard";
import AdminSuperSubscribers from "./pages/AdminSuperSubscribers";

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/account" element={<SubscriberDashboard />} />
            <Route path="/login" element={<SubscriberLogin />} />
            <Route path="/subscriber/login" element={<SubscriberLogin />} />
            <Route path="/subscriber/register" element={<SubscriberRegister />} />
            <Route path="/subscriber/forgot-password" element={<SubscriberForgotPassword />} />
            <Route path="/subscriber/reset-password" element={<SubscriberResetPassword />} />
            <Route path="/forgot-password" element={<SubscriberForgotPassword />} />
            <Route path="/reset-password" element={<SubscriberResetPassword />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="documents" element={<AdminDocuments />} />
              <Route path="upload" element={<AdminUpload />} />
              <Route path="search" element={<AdminSearch />} />
              <Route path="feedback" element={<AdminFeedback />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="subscriptions" element={<AdminSubscriptions />} />
              <Route path="password-resets" element={<AdminPasswordResets />} />
              <Route path="audit" element={<AdminAudit />} />
              <Route path="super" element={<AdminSuperDashboard />} />
              <Route path="super/subscribers" element={<AdminSuperSubscribers />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="profile" element={<AdminProfile />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
